






































import Vue from "vue";
import {Prop, Watch} from "vue-property-decorator";
import Component from "vue-class-component";
import {JobLog} from "../model/interface/job-log.interface";

@Component
export default class JobLogsComponent extends Vue {
  @Prop(Array) jobLogs!: JobLog[];
  @Prop(Number) jobHistoryId!: number;
  @Prop(Number) activateDialog!: number;

  private loading: boolean = false;
  private showDialog: boolean = false;

  private format(date: string) {
    if(date === "0" || date === null) {
      return "";
    }
    let formatted: Date = new Date(date);
    return formatted.toLocaleString('de-DE', {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric'
    });
  }

  @Watch("activateDialog")
  onDialogChange(activateDialog: number) {
    this.showDialog = true;
  }

  private cancel() {
    this.showDialog = false;
  }
}
